export default "assets/images/Vector-2-455a8c32.svg";